module.exports = __webpack_public_path__ + "img/statistics.27908c9a.png";